import React from 'react'
import '../App.css';
function SectionTitle({sectitle}) {
  return (
    <div className='sec-title'>
       <h2>
       {sectitle}
       </h2>
    </div>
  )
}

export default SectionTitle
